import ContentFilter from "@material-ui/icons/FilterList";
import React from "react";
import { Form } from "react-final-form";
import SearchIcon from "@material-ui/icons/Search";
import { Box, Button, InputAdornment } from "@material-ui/core";
import { TextInput, NullableBooleanInput, RadioButtonGroupInput, DateInput } from "react-admin";
import DivisionSelectInput from "../component/DivisionSelectInput";

const FilterButton = ({ showFilter }) => (
    <Button
        size="small"
        color="primary"
        variant="outlined"
        style={{padding: "0.5em"}}
        onClick={() => showFilter("main")}
        startIcon={<ContentFilter />}
    >
        Фільтр
    </Button>
);

const FilterForm = ({
                        displayedFilters,
                        filterValues,
                        setFilters,
                        hideFilter,
                        open
                    }) => {
    if (!displayedFilters.main) {
        return null;
    }

    const onSubmit = values => {
        if (Object.keys(values).length > 0) {
            setFilters(values);
        } else {
            hideFilter("main");
        }
    };

    const resetFilter = () => {
        setFilters({}, []);
    };

    let date = new Date();
    let month = date.getMonth() + 1;
    month = month > 9 ? month : '0' + month;

    return (
        <div>
            <Form onSubmit={onSubmit} initialValues={filterValues}>
                {({ handleSubmit }) => (
                    <form onSubmit={handleSubmit}>
                        <Box mt={2} />
                        <Box display="flex" alignItems="flex-end" mb={1}>
                            <Box component="span" mr={2}>
                                <DateInput label="з" helperText={false} source="createdAt[after]" defaultValue={date.getFullYear() + '-' + month + '-01'} />
                            </Box>
                            <Box component="span" mr={2}>
                                <DateInput label="по" helperText={false} source="createdAt[before]"  defaultValue={date.getFullYear() + '-' + month + '-' + (date.getDate() > 9 ? date.getDate() : '0' + date.getDate())} />
                            </Box>
                            <Box component="span" mr={2} mb={-2.4}>
                                <DivisionSelectInput label="Аптека" source={"division"} allowEmpty={true} />
                            </Box>
                            <Box component="span" mr={2} mb={1.5}>
                                <Button variant="outlined" color="primary" type="submit">
                                    Показати
                                </Button>
                            </Box>
                            <Box component="span" mb={1.5}>
                                <Button variant="outlined" onClick={resetFilter}>
                                    Закрити
                                </Button>
                            </Box>
                        </Box>
                    </form>
                )}
            </Form>
        </div>
    );
};

const Filter = props => {
    return props.context === "button" ? (
        <FilterButton {...props} />
    ) : (
        <FilterForm {...props} />
    )
};

export default Filter;